export default {
    name: "modals",
    _modals: null,
    _closes: null,

    init() {
        // console.log("modals.js");
        this.run();
    },

    run() {
        setTimeout(this.initModalBtn.bind(this), 1000);
        this.initModalClose();
    },

    initModalClose() {
        this._closes = document.querySelectorAll(".modal__close");

        if (!this._closes) {
            return;
        }

        for (const el of this._closes) {
            el.addEventListener("click", function (el) {
                const modal = this.closest(".modal");
                modal.classList.remove("active");
            });
        }
    },

    initModalBtn() {
        const that = this;

        this._modals = document.querySelectorAll(".modal-btn");
        if (!this._modals) {
            return;
        }

        for (const modal of this._modals) {
            modal.addEventListener("click", function (el) {
                let target;
                const modalBoxId = this.dataset.target;
                let modalData = JSON.parse(this.dataset.modalJson);

                target = document.getElementById(modalBoxId);
                target.classList.add("active");

                if (modalData) {
                    that.handleModalData(target, modalData);
                }
            });
        }
    },

    handleModalData(target, data) {
        let img = target.querySelector(".leader__image img");
        let download = target.querySelector(".leader__download");
        let desc = target.querySelector(".leader__description");
        let name = target.querySelector(".leader__name");
        let title = target.querySelector(".leader__title");
        let tel = target.querySelector(".leader__telephone");
        let email = target.querySelector(".leader__email");
        let telText = target.querySelector(".leader__telephone-text");
        let emailText = target.querySelector(".leader__email-text");

        img.src = data.img;
        download.href = data.fullImgUrl;
        desc.innerText = data.description;
        name.innerText = data.name;
        title.innerText = data.title;

        if (data.telephone) {       
            tel.style.display="block";
            tel.href = "tel:" + data.telephone;
            telText.innerText = data.telephone;
        } else {
            tel.style.display="none";
        }

        if (data.email) {
            email.style.display="block";       
            email.href = "mailto:" + data.email;
            emailText.innerText = data.email;
        } else {
            email.style.display="none";
        }
    },

};